<template>
  <img alt="Vue logo" class="logo" src="./assets/logo.png">
  <WorkPermit />
</template>

<script>
import WorkPermit from './components/WorkPermit.vue'
export default {
  name: 'App',
  components: {
    WorkPermit
  }
}
</script>

<style>
.logo{
  width: 500px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
